import { IStatusConfig } from '../../../../components/StatusBadge'
import { EstablishmentOrderStatus } from '../../../../services/Event/types'

/** Em que pé está uma venda de estabelecimento (ABRA-317): a cobrar, cobrada no checkout ou cancelada. */
export const ESTABLISHMENT_ORDER_STATUS: Record<EstablishmentOrderStatus, IStatusConfig> = {
  open: { label: 'Em aberto', colorScheme: 'orange' },
  paid: { label: 'Paga', colorScheme: 'green' },
  cancelled: { label: 'Cancelada', colorScheme: 'gray' }
}
